import { OptionsType } from '@/@types/common'
import SelectWrapper from '../wrappers/select-wrapper'

type TimeFrameType = 'weekly' | 'monthly' | 'quarterly' | 'yearly'

interface SelectTimeFrameProps {
  timeFrame: TimeFrameType
  setTimeFrame: (value: TimeFrameType) => void
  className?: string
}

const SelectTimeFrame = ({ timeFrame, setTimeFrame, className = 'w-full sm:w-[180px]' }: SelectTimeFrameProps) => {
  // Define options
  const options: OptionsType[] = [
    { value: { label: 'Weekly', value: 'weekly' }, label: 'Weekly' },
    { value: { label: 'Monthly', value: 'monthly' }, label: 'Monthly' },
    { value: { label: 'Quarterly', value: 'quarterly' }, label: 'Quarterly' },
    { value: { label: 'Yearly', value: 'yearly' }, label: 'Yearly' },
  ]

  return (
    <SelectWrapper
      options={options}
      onChange={setTimeFrame}
      // @ts-ignore
      value={timeFrame}
      placeholder='Select time frame'
      selectValue={timeFrame}
      className={className}
    />
  )
}

export default SelectTimeFrame